// import 'remodal';

export default function alertInit(cookieClass, remodalClass) {

    class Alert {


        static showAlert = () => {
            cookieClass.setCookie();
            const element = remodalClass.getInstanceFromId("alert")?  remodalClass.getInstanceFromId("alert")[0] : null;

            if (element == null) {
                throw new Error("Alert element is not available");
            }

            let remodalOpenedCheck = remodalClass.getOpenInstance();
            if(remodalOpenedCheck.length > 0 ){
                remodalClass.setTemporaryCallBack( element.openEvent );
            }else{
                element.openEvent();
            }
        }

        static alertEvent = () => {
            let time = 1000 * 60 * 4;
            setTimeout(Alert.showAlert, time );
        }

        static alertStart = () => {
            if (!cookieClass.getCookie()) {
                Alert.alertEvent();
            }
        }
    }

    return Alert;
}
